module.exports = __webpack_public_path__ + "img/banner.ceb46c78.jpg";